import { Store } from "@tanstack/store";
import { useSelector } from "@tanstack/react-store";
import { NyntaxHttpStore } from "./api/client";
import { UploadQueue } from "./upload-queue";
import { settings, SERVER_URL, API_TOKEN } from "./settings";
const queueStore = new Store<UploadQueue | null>(null);
let queueSignature = "";

/** Rebuilds the queue if the scanner name changes; keeps a stable instance
 * otherwise so the 5s drain timer isn't restarted. */
function rebuildQueueIfNeeded(): UploadQueue | null {
  const name = settings.getScannerName();
  if (name === queueSignature) return queueStore.state;
  queueSignature = name ?? "";

  // The outgoing instance owns a 5s interval and a visibilitychange
  // listener. Left running, it keeps claiming pages under the old scanner
  // name alongside the new queue.
  queueStore.state?.stopAutoRetry();

  if (!name) {
    queueStore.setState(() => null);
    return null;
  }
  const store = new NyntaxHttpStore(SERVER_URL, API_TOKEN);
  const queue = new UploadQueue(store, name);
  queue.resetStuckOnLaunch();
  queue.startAutoRetry();
  queueStore.setState(() => queue);
  return queue;
}

export function getQueue(): UploadQueue | null {
  return rebuildQueueIfNeeded();
}

export function useQueue(): UploadQueue | null {
  rebuildQueueIfNeeded();
  return useSelector(queueStore);
}
